const convertTransformerToCSS = (transformer) => ({
    '--transformer-base-default': transformer.base.default,
    '--transformer-base-action': transformer.base.action,
    '--transformer-base-active': transformer.base.active,
    '--transformer-base-active-active': transformer.base.activeAction,
    '--transformer-text-default': transformer.text.default,
    '--transformer-text-action': transformer.text.action,
    '--transformer-text-active': transformer.text.active,
    '--transformer-text-active-action': transformer.text.activeAction,
});
const convertTransformerToObject = (transformer) => ({
    transformerBaseDefault: transformer.base.default,
    transformerBaseAction: transformer.base.action,
    transformerBaseActive: transformer.base.active,
    transformerBaseActiveActive: transformer.base.activeAction,
    transformerTextDefault: transformer.text.default,
    transformerTextAction: transformer.text.action,
    transformerTextActive: transformer.text.active,
    transformerTextActiveAction: transformer.text.activeAction,
});
const Transformer = {
    base: {
        default: 'var(--transformer-base-default)',
        action: 'var(--transformer-base-action)',
        active: 'var(--transformer-base-active)',
        activeAction: 'var(--transformer-base-active-action)',
    },
    text: {
        default: 'var(--transformer-text-default)',
        action: 'var(--transformer-text-action)',
        active: 'var(--transformer-text-active)',
        activeAction: 'var(--transformer-text-active-action)',
    },
};

export { Transformer, convertTransformerToCSS, convertTransformerToObject };
